/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssociatedResultTemplateUpdateDTO,
    AssociatedResultTemplateUpdateDTOFromJSON,
    AssociatedResultTemplateUpdateDTOFromJSONTyped,
    AssociatedResultTemplateUpdateDTOToJSON,
} from './AssociatedResultTemplateUpdateDTO';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface CompetenceTemplateUpdateDTO
 */
export interface CompetenceTemplateUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof CompetenceTemplateUpdateDTO
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof CompetenceTemplateUpdateDTO
     */
    type?: LearningCompetenceTypeEnum;
    /**
     * 
     * @type {Array<AssociatedResultTemplateUpdateDTO>}
     * @memberof CompetenceTemplateUpdateDTO
     */
    associatedResults?: Array<AssociatedResultTemplateUpdateDTO> | null;
}

export function CompetenceTemplateUpdateDTOFromJSON(json: any): CompetenceTemplateUpdateDTO {
    return CompetenceTemplateUpdateDTOFromJSONTyped(json, false);
}

export function CompetenceTemplateUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetenceTemplateUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
        'associatedResults': !exists(json, 'associatedResults') ? undefined : (json['associatedResults'] === null ? null : (json['associatedResults'] as Array<any>).map(AssociatedResultTemplateUpdateDTOFromJSON)),
    };
}

export function CompetenceTemplateUpdateDTOToJSON(value?: CompetenceTemplateUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
        'associatedResults': value.associatedResults === undefined ? undefined : (value.associatedResults === null ? null : (value.associatedResults as Array<any>).map(AssociatedResultTemplateUpdateDTOToJSON)),
    };
}

